'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { SearchBar } from '@/components/SearchBar';

const icon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" aria-hidden="true">
    <path opacity="0.4" d="M17.5 17.5671L14.5834 14.6504" stroke="#CBCDD6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.58333 16.7338C13.4954 16.7338 16.6667 13.5625 16.6667 9.65047C16.6667 5.73845 13.4954 2.56714 9.58333 2.56714C5.67132 2.56714 2.5 5.73845 2.5 9.65047C2.5 13.5625 5.67132 16.7338 9.58333 16.7338Z" stroke="#CBCDD6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ProductsTopSection = ({ title }) => {
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState('');

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && searchQuery.trim()) {
      const url = `/professionals/lifetime-mortgages/lending-criteria?search=${encodeURIComponent(searchQuery)}`;
      router.push(url);
    }
  };

  return (
    <section className="bg-[#0A1628]">
      <div className="container">
        <div className="pt-4 md:pt-10 pb-10 flex flex-col md:flex-row md:items-center md:justify-between">
          <h1 className="text-white text-xl text-center md:text-left font-semibold mb-8 md:mb-0">
            {title}
          </h1>
          <SearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            onKeyPress={handleKeyPress}
            backgroundColour="#0A1628"
            showButton={false}
            icon={icon}
            iconPosition="left-6"
            placeHolderPosition="pl-14"
          />
        </div>
      </div>
    </section>
  );
};
